<template>
  <li
    class="grid gap-2 py-6 border-b md:grid-cols-subgrid md:grid-rows-subgrid md:row-span-2"
  >
    <template v-if="links">
      <MBZCTADefault
        class="text-h5"
        icon="arrow"
        icon-position="right"
        :url="links"
        :label="title as string"
      />
    </template>
    <template v-else>
      <h5 class="text-h5">
        {{ title }}
      </h5>
    </template>
    <slot name="summary" />
  </li>
</template>

<script setup lang="ts">
import type { Link } from '~/types';

defineProps<{
  title: string | string[];
  links?: Link;
}>();

defineSlots<{
  summary(): any;
}>();
</script>
